import React from 'react';
import { BookOpenCheckIcon, CalendarDaysIcon, CheckIcon, ClipboardListIcon, UsersIcon } from 'lucide-react';
const stats = [[BookOpenCheckIcon, '600+', 'Páginas'], [CalendarDaysIcon, '400+', 'Sesiones'], [ClipboardListIcon, '250+', 'Ejercicios y juegos'], [UsersIcon, '12', 'Tomos escolares']];
const tags = ['1º a 6º de Primaria', '1º a 6º de Secundaria', 'Psicomotricidad', 'Iniciación deportiva', 'Condición física y salud', 'Planificación anual'];
export function SystemSection() {
  return <section className="border-y-4 border-emerald-400 bg-[#10372a] px-5 py-20" data-id="element-203" data-mp="2wsfoxsbjd4iz">
      <div className="mx-auto max-w-6xl text-center" data-id="element-204" data-mp="2stgnihp0jpwa">
        <p className="inline-block bg-emerald-400 px-4 py-2 text-xs font-bold uppercase tracking-widest text-[#09281d]" data-id="element-205" data-mp="2sq197h35ykvx">
          El sistema más completo para el profesor de Educación Física
        </p>
        <h2 className="mt-7 font-display text-5xl font-bold uppercase leading-none text-white sm:text-7xl" data-id="element-206" data-mp="2dv4oi4e6451y">
          Educación Física <span className="text-emerald-300" data-id="element-207" data-mp="13yy6rjnlsbj6">Lista</span>
        </h2>
        <p className="mx-auto mt-6 max-w-3xl text-base font-medium leading-relaxed text-slate-300" data-id="element-208" data-mp="18py2wmowepkm">
          <strong className="text-white" data-id="element-209" data-mp="u11z51tvjypt">PACK EDUCACIÓN FÍSICA LISTA™</strong>{' '}
          reúne más de 600 páginas de planes de sesión, ejercicios técnicos,
          juegos, guías de acondicionamiento físico y herramientas de gestión de
          clase — <strong className="text-white" data-id="element-210" data-mp="1mr0sh9f3qi0a">todo hecho por ti.</strong>
        </p>
        <div className="mt-11 grid grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-211" data-mp="1rp29zpwvq99n">
          {stats.map(([Icon, value, label]) => <div key={label} className="border border-emerald-300/25 bg-[#09281d] p-6" data-id="element-212" data-mp="1cqqe3lhbz4jj">
              <Icon className="mx-auto h-7 w-7 text-emerald-300" data-id="element-213" data-mp="1hsph2u95rzfy" />
              <p className="mt-4 font-display text-4xl font-bold text-white" data-id="element-214" data-mp="1bla8e5gqzyc">
                {value}
              </p>
              <p className="text-xs font-bold uppercase tracking-widest text-slate-300" data-id="element-215" data-mp="6cr44fav0t9g">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-4 border border-emerald-300/25 bg-[#09281d] p-7" data-id="element-216" data-mp="240cs4v3chgjz">
          <p className="text-xs font-bold uppercase tracking-[.2em] text-white" data-id="element-217" data-mp="1z7s3s937jvnu">
            Cobertura completa, toda la trayectoria escolar
          </p>
          <div className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-218" data-mp="1u74athvf54qz">
            {tags.map(tag => <span key={tag} className="flex items-center gap-1.5 border border-emerald-300/25 bg-[#10372a] px-3 py-2 text-xs font-bold text-white" data-id="element-219" data-mp="1p7ss43bhrp6r">
                <CheckIcon className="h-3.5 w-3.5 text-emerald-300" data-id="element-220" data-mp="1gbad7v03i1t6" />
                {tag}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}